import Vue from "vue";
import Vuex from "vuex";
import {
  getPublicParams,
  setPublicParams,
  removePublicParams,
} from "@/util/publicParams";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    gameData: {},
    public_param: getPublicParams(),
    userInfoUpdated: 0,
    target: ''
  },
  mutations: {
    setTarget(state, data) {
      state.target = data;
    },
    SET_PUBLIC_PARAM: (state, public_param) => {
      state.public_param = public_param;
      setPublicParams(public_param);
    },
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setUserMobile(state, data) {
      state.userInfo.mobile = data;
    },
    setGameData(state, data) {
      state.gameData = data;
    },
    setUserInfoUpdated(state, data) {
      state.userInfoUpdated = data;
    }
  },
  actions: {
    setPublicParam({ commit }, public_param) {
      commit("SET_PUBLIC_PARAM", public_param);
    },

    removePublicParam({ commit }) {
      commit("SET_PUBLIC_PARAM", {});
      removePublicParams();
    },
  },
  modules: {},
});
